var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "booking-section",
    {
      attrs: {
        id: "services",
        title: `Weitere Leistungen`,
        contentClass: "",
        contentClass: "",
        collapsed: _vm.moduleCollapsed,
      },
      on: { "section-clicked": _vm.sectionClicked },
    },
    [
      _vm.loaded
        ? _c(
            "div",
            {
              staticClass: "booking__services",
              attrs: { id: "booking_services_table" },
            },
            [
              _c(
                "div",
                { staticClass: "spacer" },
                [
                  _vm._l(_vm.result.services, function (data, di) {
                    return _vm.servicesEnabled
                      ? _c("div", [
                          data.values.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "booking__title clickable",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection(data.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      class: `${
                                        di != 0
                                          ? "selectable-services-header"
                                          : ""
                                      } product-list-description`,
                                    },
                                    [
                                      di != 0
                                        ? _c(
                                            "span",
                                            { staticClass: "services-counter" },
                                            [_vm._v(_vm._s(di) + ".)")]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            data.name.replace(/[0-9]{1,}\./, "")
                                          ) +
                                          "\n            "
                                      ),
                                      di != 0
                                        ? _c("div", {
                                            staticClass:
                                              "arrow-indicator close",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row services-section",
                              attrs: { id: data.id },
                            },
                            _vm._l(data.values, function (service) {
                              return _c(
                                "div",
                                {
                                  class: `small-12 columns ${
                                    di == 0
                                      ? "medium-12 large-12"
                                      : "medium-4 large-4"
                                  }`,
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "booking-element" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row white-bg" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class: `small-12 columns ${
                                                di == 0
                                                  ? "medium-4 large-4"
                                                  : "medium-12 large-12"
                                              }`,
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "booking__extra__img",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: service.picture_url,
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class: `small-12 columns ${
                                                di == 0
                                                  ? "medium-8 large-8"
                                                  : "medium-12 large-12"
                                              }`,
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "text-gold" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(service.name)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                class: !service.mandatory
                                                  ? "services-description"
                                                  : "",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    service.description
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              !service.mandatory && di != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "price-display text-right spacer-small",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "teaser",
                                                        },
                                                        [
                                                          service.price ==
                                                          "0,00"
                                                            ? _c("b", [
                                                                _vm._v(
                                                                  "kostenfrei"
                                                                ),
                                                              ])
                                                            : _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    service.price
                                                                  ) + " EUR"
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              service.amount_type.join(
                                                                ", "
                                                              )
                                                            ) +
                                                            ", " +
                                                            _vm._s(
                                                              service.person_details
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        service.kids_prices,
                                                        function (kid) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "metainfo text-right",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      Kind " +
                                                                  _vm._s(
                                                                    kid.name
                                                                  ) +
                                                                  " - " +
                                                                  _vm._s(
                                                                    kid.price
                                                                  ) +
                                                                  " EUR\n                    "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !service.mandatory && di != 0
                                                ? _c("div", [
                                                    service.booking_type ==
                                                    "per_amount"
                                                      ? _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                service.amount,
                                                              expression:
                                                                "service.amount",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "underline",
                                                          attrs: {
                                                            type: "number",
                                                            min: "0",
                                                          },
                                                          domProps: {
                                                            value:
                                                              service.amount,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                service,
                                                                "amount",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isSelected(service.id)
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cta cta--inline cta--dark",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeService(
                                                                  service.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Entfernen")]
                                                        )
                                                      : _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "cta cta--inline cta",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.addService(
                                                                  service.id,
                                                                  service.booking_type ==
                                                                    "per_amount"
                                                                    ? +service.amount
                                                                    : 1
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Wählen")]
                                                        ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          di == 0
                            ? _c("div", { staticClass: "booking__title" }, [
                                _c("h3", [_vm._v("Zubuchbare Leistungen")]),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "booking__title clickable",
                      on: {
                        click: function ($event) {
                          return _vm.toggleSection("insurance")
                        },
                      },
                    },
                    [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.result.insurance.content.title)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "column small-12 medium-6" }, [
                      _c(
                        "a",
                        {
                          staticClass: "cta cta--dark",
                          on: {
                            click: function ($event) {
                              _vm.insuranceVisble = true
                            },
                          },
                        },
                        [_vm._v("Reiserücktrittsversicherung abschließen")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column small-12 medium-6 spacer" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "cta",
                            on: {
                              click: function ($event) {
                                return _vm.sendBookingProceed()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "Ich verzichte auf eine Reiserücktrittsversicherung"
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.insuranceVisble
                    ? _c("div", { attrs: { id: "insurance" } }, [
                        _c("div", {
                          staticClass: "small",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.result.insurance.content.text
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "row spacer" }, [
                          _c("div", { staticClass: "small-12 medium-12" }, [
                            _c("p", { staticClass: "spacer--top" }, [
                              _vm._v(
                                "Bitte geben Sie die Anzahl der mitreisenden Personen mit einem Alter über 64 Jahren an um sich die passenden Versicherungstarife anzuzeigen:"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "small-12 medium-12" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.seniors,
                                  expression: "seniors",
                                },
                              ],
                              staticClass: "underline",
                              attrs: {
                                type: "number",
                                min: "0",
                                max: _vm.result.global.details.adults,
                              },
                              domProps: { value: _vm.seniors },
                              on: {
                                change: function ($event) {
                                  return _vm.getInsurance()
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.seniors = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "cta cta--inline cta--white",
                                on: {
                                  click: function ($event) {
                                    return _vm.getInsurance()
                                  },
                                },
                              },
                              [_vm._v("Verfügbare Tarife anzeigen")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.noInsurance != true
                          ? _c("div", { staticClass: "row" }, [
                              _vm.result.insurance.plans
                                ? _c(
                                    "div",
                                    {
                                      key: _vm.result.insurance.plans.length,
                                      staticClass: "small-12 booking-element",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { id: "insurance-container" },
                                        },
                                        _vm._l(
                                          _vm.result.insurance.plans,
                                          function (plan) {
                                            return _c(
                                              "div",
                                              { staticClass: "spacer" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row plan" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column small-12 medium-4",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-gold",
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  plan.productName
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-xsmall",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "small spacer-small",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    plan.description
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            plan.description.match(
                                                              plan.detailsUrl
                                                            ) == null
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "text-small",
                                                                    attrs: {
                                                                      href: plan.detailsUrl,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Produktinformationen"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column small-6 medium-4 text-right",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "teaser",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  plan.formattedPriceWithoutOwnRisk
                                                                ) +
                                                                " EUR"
                                                            ),
                                                            _c("br"),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-xsmall",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(ohne Selbstbehalt)"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.selectedInsuranceId &&
                                                        _vm.selectedInsuranceId ==
                                                          `${plan.id}.false`
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "cta cta--dark",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeInsurance()
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("Entf.")]
                                                            )
                                                          : _vm.selectedInsuranceId ==
                                                            null
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-right",
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "cta cta cta--inline cta--white",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectInsurance(
                                                                            plan,
                                                                            false,
                                                                            null
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Wählen"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column small-6 medium-4 text-right",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "teaser",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                plan.formattedPriceWithOwnRisk
                                                              ) + " EUR"
                                                            ),
                                                            _c("br"),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-xsmall",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(mit 20% Selbstbehalt)"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.selectedInsuranceId &&
                                                        _vm.selectedInsuranceId ==
                                                          `${plan.id}.true`
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "cta cta--dark",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeInsurance()
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("Entf.")]
                                                            )
                                                          : _vm.selectedInsuranceId ==
                                                            null
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-right",
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "cta cta cta--inline cta--white",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectInsurance(
                                                                            plan,
                                                                            true,
                                                                            null
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Wählen"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  plan.options,
                                                  function (planOpt) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row option",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "column small-12 medium-4",
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "inkl. " +
                                                                  _vm._s(
                                                                    planOpt.productName
                                                                  )
                                                              ),
                                                            ]),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "text-xsmall",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "small spacer-small",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        planOpt.description
                                                                      ),
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                planOpt.description.match(
                                                                  planOpt.detailsUrl
                                                                ) == null
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: plan.detailsUrl,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Produktinformationen"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "column small-6 medium-4 text-small text-right",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "teaser",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      planOpt.formattedPriceWithoutOwnRisk
                                                                    ) +
                                                                    " EUR"
                                                                ),
                                                                _c("br"),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-xsmall",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(ohne Selbstbehalt)"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.selectedInsuranceId &&
                                                            _vm.selectedInsuranceId ==
                                                              `${planOpt.id}.false`
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "cta cta--dark",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeInsurance()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Entf."
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm.selectedInsuranceId ==
                                                                null
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-right",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "cta cta cta--inline cta--white",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.selectInsurance(
                                                                                plan,
                                                                                false,
                                                                                planOpt
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Wählen"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "column small-6 medium-4 text-small text-right",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "teaser",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    planOpt.formattedPriceWithOwnRisk
                                                                  ) + " EUR "
                                                                ),
                                                                _c("br"),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-xsmall",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(mit 20% Selbstbehalt)"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.selectedInsuranceId &&
                                                            _vm.selectedInsuranceId ==
                                                              `${planOpt.id}.true`
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "cta cta--dark",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeInsurance()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Entf."
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm.selectedInsuranceId ==
                                                                null
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-right",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "cta cta cta--inline cta--white",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.selectInsurance(
                                                                                plan,
                                                                                true,
                                                                                planOpt
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Wählen"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.insuranceVisble
                ? _c(
                    "div",
                    { staticClass: "booking-element" },
                    [
                      _vm.reloading
                        ? _c("loader", {
                            attrs: {
                              title: "Ergebnis wird geladen",
                              details: "Einen Moment bitte",
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "booking__prices sans-serif" },
                            [
                              _vm.selectedInsurance
                                ? _c(
                                    "div",
                                    { staticClass: "row price-details-entry" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns large-5 medium-5 small-12 is-bootybox-col",
                                        },
                                        [_vm._v("Gewählte Versicherung")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "columns large-5 medium-5 small-12 is-bootybox-col",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.selectedInsurance.plan
                                                  .productName
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _vm.selectedInsurance.opt
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                inkl. " +
                                                    _vm._s(
                                                      _vm.selectedInsurance.opt
                                                        .productName
                                                    ) +
                                                    " "
                                                ),
                                                _c("br"),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "cta",
                          on: {
                            click: function ($event) {
                              return _vm.sendBookingProceed()
                            },
                          },
                        },
                        [_vm._v("Buchung abschließen")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _c("loader", {
            attrs: {
              title: "Verfügbare Serviceleistungen werden geladen",
              details: "Einen Moment bitte",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }